import { env, httpRequest } from '@utils';
import { getUser } from '@utils/auth';
import Toast from '@/components/IToast';
import router from '../router/index.js';
import { CoolClearUserInfo } from '@igetcool/cool-mobile-ui';
import { getOutsideAuth } from '@utils/outsideAuth';

const SUCCESS_CODE = 10000;
const REDIRECT_CODE = 8000;
const WECHAT_PAY_CODE = 10006;

let putType = 1;
if (env.isApp) {
  putType = 2;
}
// config.handleError
/**
 *
 * @param config
 * config.outOrder:xxx
 * config.handleError:允许用户自定义错误处理函数
 * config.xxx:xxx
 * ...
 */
const requrest = (url, data, method, config) => {
  method = method.toLowerCase();
  const userInfo = JSON.parse(getUser());
  const headers = {};
  if (userInfo) {
    if (env.isApp) {
      headers['Shop-PutType'] = putType;
      headers['App-Device-Key'] = userInfo['App-Device-Key'];
      headers['App-Device-Du-Key'] = userInfo['App-Device-Du-Key'];
      headers['App-Device-Type'] = userInfo['App-Device-Type'];
      headers['APP-Agent'] = userInfo['APP-Agent'];
      headers['App-Sign'] = userInfo['App-Sign'];
      headers['App-User-Pid'] = userInfo['uid'];

      headers['App-Channel'] = userInfo['App-Channel'];
      headers['App-Version'] = userInfo['App-Version'];
      headers['isLogin'] = userInfo['isLogin'];

    } else {
      headers['Shop-PutType'] = putType;
      headers['App-User-Pid'] = userInfo.uid;
      headers['Shop-Authorization'] = userInfo.token || userInfo.wxtoken;
      if (userInfo.wxtoken) {
        headers['Wx-Token'] = userInfo.wxtoken;
      }
    }
  }

  // 蔚来汽车带过来的用户信息
  const outsideAuthInfo = getOutsideAuth();
  if (outsideAuthInfo) {
    headers['Outside-Token'] = outsideAuthInfo.appId + ',' + outsideAuthInfo.unionId + ',' + outsideAuthInfo.token;
  }


  let newUrl = `/mall-server/api/${url}`;
  if (config && config.outOrder) {
    newUrl = `/growth-server/${url}`;
  }
  return new Promise((resolve, reject) => {
    httpRequest[method](newUrl, data, {
      timeout: 7000,
      headers,
      forceAjax: true,
    })
      .then((res) => {
        if (res.code == SUCCESS_CODE) {
          resolve(res);
          return;
        }

        if (res.code == REDIRECT_CODE) {
          //  加购需登录存缓存
          if (url === 'shop/trolley/addShoppingTrolley' || url === 'shop/trolley/addTrolley') {
            sessionStorage.setItem('storageShoppingCourse', JSON.stringify(data));
          }
          if (url === 'shop/trolley/addCombinatShoppingTrolley' || url === 'shop/trolley/addCombTrolley') {
            sessionStorage.setItem('storageShoppingCourse', JSON.stringify(data));
            sessionStorage.setItem('storageShoppingJuheMark', true);
          }
          CoolClearUserInfo();
          const search = location.search;
          const redirect = location.pathname;
          if (location.href.indexOf('login') === -1) {
            router.replace({
              path: `/mall/login${
                search ? `${search}&` : '?'
              }redirect=${redirect}`,
            });
            reject(res);
          }
          return;
        }

        // if (res.code !== WECHAT_PAY_CODE) Toast(res.msg);
        if (res.code !== '8001') {
          if (res.code == '310001' || res.code == '200006') {
            resolve(res);
            return;
          } else {
            if (config && config.handleError) {
              config.handleError(res);
            } else if (res.msg) {
              res && res.msg && Toast(res.msg);
            }
          }
        }
        reject(res);
      })
      .catch((err) => {
        // Toast({
        //   text: '网络异常,稍后再试',
        //   time: 5000,
        // });

        // return;
        reject(err);
      });
  });
};

export const get = (url, params, config) => requrest(url, params, 'GET', config);

export const post = (url, data, config) => requrest(url, data, 'POST', config);
